import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el Kit después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos ya tenés todo descargado en tu dispositivo. 100% PDF, sin apps ni plataformas extras.'
  }, {
    q: '¿Sirve para mi provincia o solo para Buenos Aires?',
    a: 'El Kit está diseñado con contenidos de Psicología que se adaptan a los diseños curriculares de todas las provincias argentinas. Los ejes temáticos (corrientes psicológicas, procesos mentales, identidad, emociones) son universales en la currícula de secundaria.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'El material viene en PDF listo para usar. La planificación anual viene en formato editable para que la adaptes a tu institución y contexto particular.'
  }, {
    q: '¿Los 2 bonos están en todas las ofertas?',
    a: 'Sí, tanto el Kit Completo como el Pack Premium incluyen los 2 bonos: Planificación Anual Lista y Banco de Dinámicas Psicológicas para el Aula.'
  }, {
    q: '¿Puedo comprar solo el Kit Completo ahora y el Premium después?',
    a: 'Sí, podés empezar con el Kit Completo y luego actualizar al Pack Premium. Pero te recomendamos aprovechar el precio de lanzamiento del Premium porque después sube.'
  }, {
    q: '¿Funciona para escuelas con pocos recursos?',
    a: 'Absolutamente. Todo el material está pensado para funcionar con recursos accesibles. No necesitás laboratorio, proyector ni materiales especiales. Solo imprimís y usás.'
  }, {
    q: '¿Sirve para cursos difíciles o con mucho desorden?',
    a: 'Sí. Las secuencias didácticas incluyen dinámicas participativas y actividades que captan la atención. Muchos docentes nos cuentan que sus clases mejoraron notablemente con el material.'
  }, {
    q: '¿Está actualizado al currículo vigente?',
    a: 'Sí, el contenido está alineado con los Núcleos de Aprendizajes Prioritarios (NAP) y los diseños curriculares vigentes para Psicología en secundaria argentina.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días para revisar todo el material. Si no cumple tus expectativas, te devolvemos el 100% del dinero. Sin preguntas, sin vueltas.'
  }, {
    q: '¿Qué diferencia tiene el Kit con otros materiales que vi?',
    a: 'Este Kit es un sistema completo: no son actividades sueltas ni PDFs genéricos. Incluye planificación anual, secuencias didácticas por unidad, proyecto integrador, evaluaciones con rúbricas, dinámicas y educación emocional. Todo organizado y listo para usar desde el día 1.'
  }];
  return <section className="bg-[#0a0e27] py-6 md:py-8 px-4 font-sans" data-id="element-52">
      <div className="max-w-3xl mx-auto" data-id="element-53">
        <h2 className="text-3xl md:text-5xl font-extrabold text-center mb-5 flex items-center justify-center gap-3" data-id="element-54">
          <span className="text-3xl md:text-5xl" data-id="element-55">❓</span>
          <span data-id="element-56">
            <span className="text-white" data-id="element-57">PREGUNTAS </span>
            <span className="text-[#22c55e]" data-id="element-58">FRECUENTES</span>
          </span>
        </h2>

        <div className="space-y-2" data-id="element-59">
          {faqs.map((faq, i) => <div key={i} className="bg-[#111638] border border-gray-800 rounded-lg overflow-hidden transition-all duration-200" data-id="element-60">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-3 md:p-4 text-left group" data-id="element-61">
                <div className="flex items-center gap-3 flex-1" data-id="element-62">
                  <span className="text-[#22c55e] font-bold text-sm md:text-base whitespace-nowrap" data-id="element-63">
                    {i + 1} —
                  </span>
                  <span className="font-bold text-white text-sm md:text-base" data-id="element-64">
                    {faq.q}
                  </span>
                </div>
                <span className="text-gray-500 ml-3 flex-shrink-0 text-xs" data-id="element-65">
                  {openIndex === i ? '▲' : '▼'}
                </span>
              </button>
              {openIndex === i && <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0 ml-10 md:ml-12" data-id="element-66">
                  <p className="text-gray-400 text-sm md:text-base leading-relaxed border-t border-gray-800 pt-3" data-id="element-67">
                    {faq.a}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}